// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import NestedForm from 'stimulus-rails-nested-form'

import AppearController from './appear_controller'

import ApplicationController from './application_controller'

import CloneMarkerController from './clone_marker_controller'

import ConfirmFieldController from './confirm_field_controller'

import CopyToClipboardController from './copy_to_clipboard_controller'

import DelayedRemoveController from './delayed_remove_controller'

import DialogController from './dialog_controller'

import DisclosureController from './disclosure_controller'

import DropdownController from './dropdown_controller'

import ProgressController from './progress_controller'

import TabsController from './tabs_controller'

import TimeagoController from '@stimulus-components/timeago'

application.register('nested-form', NestedForm)
application.register('appear', AppearController)
application.register('application', ApplicationController)
application.register('clone-marker', CloneMarkerController)
application.register('confirm-field', ConfirmFieldController)
application.register('copy-to-clipboard', CopyToClipboardController)
application.register('delayed-remove', DelayedRemoveController)
application.register('dialog', DialogController)
application.register('disclosure', DisclosureController)
application.register('dropdown', DropdownController)
application.register('progress', ProgressController)
application.register('tabs', TabsController)
application.register('timeago', TimeagoController)
